module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.19640/images/illustrations/account-ready.svg"